import React from 'react';
import styled from 'styled-components';
import cameraIcon from 'images/icon/camera_icon-27x22.png'
import closeBtnIcon from 'images/icon/close_btn_grey_circle-18x18.png'

import LoadingAnimation from 'components/presenters/common/LoadingAnimation';
export default function TaskResultFormModal({modalId, description, isValid, isImgLoading, displayImg, onClose , onCancelImg, onSelectImg, onChangeDescription, onSubmit}) { 
	
	return (
		<ModalSection onClick={(e)=>{
			if(onClose && e.currentTarget === e.target)
			{
				onClose();
			}
		}}>
			<ModalWrapper>
				<ModalHeader>
					<HeaderLeft onClick={()=>{if(onClose)onClose();}}>취소</HeaderLeft>
					<HeaderMid>인증하기</HeaderMid>
					{
						(isValid)
						?(<HeaderRightValid onClick={()=>{if(onSubmit)onSubmit()}}>완료</HeaderRightValid>)
						:(<HeaderRight>완료</HeaderRight>)
					}
					
				</ModalHeader>
				<ModalBody>
					{
						(displayImg !== null)
						?(
							<PreviewImgWrapper>
								<DeletePreviewImgBtnWrapper onClick={()=>{if(onCancelImg)onCancelImg()}}>
									<DeletePreviewImgBtn src={closeBtnIcon}/>
								</DeletePreviewImgBtnWrapper>
								<PreviewImg src={displayImg}/>

								{
									(isImgLoading && (
										<LoadingImgWrapper>
											<LoadingAnimation />
										</LoadingImgWrapper>
									))
								}
							</PreviewImgWrapper>)
						:(
							<SelectImgWrapper onClick={()=>{if(onSelectImg)onSelectImg()}}> 
								<SelectImgIcon src={cameraIcon}/> 
								{
									(isImgLoading && (
										<LoadingImgWrapper> 
											<LoadingAnimation />
										</LoadingImgWrapper>
									))
								}
							</SelectImgWrapper>
						)
					}
					<DescriptionAreaWrapper>
						<DescriptionArea placeholder={'인증 기록을 남겨보세요 :)'} onChange={(e)=>{if(onChangeDescription)onChangeDescription(e.target.value)}} value={(description)?description:''} />
					</DescriptionAreaWrapper>
				</ModalBody>
			</ModalWrapper>
		</ModalSection>
	);
	
} 
export const LoadingCanvasAnimation = styled.canvas`
	width : calc(100vw * (40 / 375));
	height : calc(100vw * (40 / 375));
`;
export const ModalSection = styled.div`
	position:fixed;
	z-index: 500;
	top:0;
	left:0;
	right:0;
	bottom:0;
	width: 100%; 
	height: 100%;
	background: rgba(0,0,0,0.5);;

`
export const ModalWrapper = styled.div`
	position:fixed;
	z-index: 500;
	bottom:0;
	width: 100%;
	background: white;

	box-shadow: 0px 2px 8px rgba(133, 133, 133, 0.26);
	border-radius: 14px 14px 0px 0px;
	padding: calc(100vw * (18 / 375)) calc(100vw * (20 / 375)) calc(100vw * (32 / 375)) calc(100vw * (20 / 375));
`
export const ModalHeader = styled.div` 
	display: flex;
	justify-content: space-between;
	margin-bottom : calc(100vw * (27 / 375)) ; 
`
export const DefaultHeaderFont = styled.div` 
	font-style: normal;
	font-weight: 500;
`
export const HeaderLeft = styled(DefaultHeaderFont)`
	font-size: calc(100vw * (16 / 375));
	line-height: calc(100vw * (20 / 375)) ;
	color: #707070;
`
export const HeaderMid = styled(DefaultHeaderFont)`
	font-size: calc(100vw * (16 / 375));
	line-height: calc(100vw * (23 / 375));
	color: #000000;
`
export const HeaderRight = styled(DefaultHeaderFont)` 
	font-size: calc(100vw * (16 / 375));
	line-height: calc(100vw * (23 / 375)) ; 
	color: #BCBDBF;
`
export const HeaderRightValid = styled(HeaderRight)`  
	color: #FECE37;
	font-weight: 700;
`

export const ModalBody = styled.div` 
	display: flex;

`
export const LoadingImgWrapper = styled.div`
	position:absolute;
	left:0;
	right: 0;
	top:0;
	bottom:0;
	margin: auto;
	height: calc(100vw * (40 / 375));
	width : calc(100vw * (40 / 375));
`
   

export const PreviewImgWrapper = styled.div`
	position: relative;
	flex: 0 1 auto;
	background: #F7F7F7;
	border-radius: 9px;
	overflow: hidden;
	width : calc(100vw * (115 / 375));
	height: calc(100vw * (115 / 375));
	border: 1px solid #EAEAEA;
	min-width: calc(100vw * (115 / 375));
    min-height: calc(100vw * (115 / 375));
`

export const SelectImgWrapper = styled.div` 
	position: relative;
	flex: 0 1 auto;
	background: #F7F7F7;
	border-radius: 9px;
	width : calc(100vw * (115 / 375));
	height: calc(100vw * (115 / 375));
	min-width: calc(100vw * (115 / 375));
    min-height: calc(100vw * (115 / 375));
`
export const SelectImgIcon = styled.img` 
	position : absolute;
	top: 0;
	bottom : 0;
	left: 0;
	right: 0;
	width : calc(100vw * (27 / 375));
	height : calc(100vw * (22 / 375));
	margin: auto;
`

export const DeletePreviewImgBtnWrapper = styled.span`
	z-index: 550;
	display: inline-block;
	position:absolute;
	top: calc(100vw * (8 / 375));
	right: calc(100vw * (8 / 375));
`;
export const DeletePreviewImgBtn = styled.img``;
export const DescriptionAreaWrapper = styled.div`
	flex: 1 1 auto;
	padding-left: calc(100vw * (10 / 375));
`
export const DescriptionArea = styled.textarea`
	appearance: none;
	-moz-appearance: none;
	-webkit-appearance: none;
	width : 100%;
	height: 100%;
	border: 1px solid #EFEFEF;
	box-sizing: border-box;
	border-radius: calc(100vw * (9 / 375));
	padding: calc(100vw * (14 / 375)) calc(100vw * (13 / 375)) calc(100vw * (8 / 375)) calc(100vw * (13 / 375));
 
	font-style: normal;
	font-weight: normal;
	font-size: calc(100vw * (14 / 375));
	line-height: calc(100vw * (20 / 375)); 
	color: #121212;
	&:focus{
		border :1px solid #FFCF19
	}
	&::placeholder{ 
		font-style: normal;
		font-weight: normal;
		font-size: calc(100vw * (14 / 375));
		line-height: calc(100vw * (20 / 375));
		color: #BCBDBF
	}
`
export const PreviewImg = styled.img`
	width : 100%;
	height: 100%;
	object-fit:cover;
`